const twoFactorActiveModes = ['force', 'optional'];

export default function isTwoFactorEnabled(mode) {
  return twoFactorActiveModes.includes(mode);
}
